<template>
  <esg-base-list name="disclosure-templates"
                 ref="disclosure-template-list"
                 :clickable="true"
                 @rowClicked="showDetail">
    <template #actions>
      <esg-base-button variant="primary"
                       size="sm"
                       @click="showNew">생성
      </esg-base-button>
    </template>
  </esg-base-list>
</template>

<script>
import EsgBaseList from "@/components/esg/base/EsgBaseList.vue";
import EsgBaseButton from "@/components/esg/base/EsgBaseButton.vue";

export default {
  name: "EsgDisclosureTocTypeList",
  components: { EsgBaseButton, EsgBaseList },
  activated() {
    this.$refs['disclosure-template-list'].$refs['table'].initialize();
  },
  methods: {
    showDetail(disclosure) {
      this.pushRoute({ name: "disclosureTemplateDetail", params: { id: disclosure.id } });
    },
    showNew() {
      this.pushRoute('/esg/disclosure-templates/new')
    }
  },
}
</script>